// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-row[data-v-49aa279a]{font-size:16px;line-height:32px;margin-bottom:20px}", ""]);
// Exports
module.exports = exports;
